import { Box, Typography } from "@mui/material";
import React from "react";

export default function LogoLine({ text, sx }) {
  return (
    <Box
      className="displayCenter"
      sx={{ marginBottom: "60px", padding: "0px 20px", ...sx }}
    >
      <Box sx={{ width: "100%", background: "#8C8C8C", height: "1.5px" }} />
      <Box>
        {text ? (
          <Box pr={2} pl={2}>
            <Typography variant="body1">{text}</Typography>
          </Box>
        ) : (
          <img src="/assets/logo/logo_circle.png" alt="" />
        )}
      </Box>
      <Box sx={{ width: "100%", background: "#8C8C8C", height: "1.5px" }} />
    </Box>
  );
}
